import React from 'react'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'

Bugsnag.start({
  apiKey: process.env.REACT_APP_BUGSNAG_API,
  plugins: [new BugsnagPluginReact()],
  appVersion: process.env.REACT_APP_VERSION,
  onError: event => {
    // Ruido benigno del navegador, no un bug: el ResizeObserver difiere
    // notificaciones al siguiente frame. No aporta señal, lo descartamos.
    const message = event.errors?.[0]?.errorMessage ?? ''
    if (message.startsWith('ResizeObserver loop')) return false
  },
})

const BugsnagErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React)

export { BugsnagErrorBoundary }
